import { Award, CheckCircle, TrendingUp, Users } from "lucide-react";
import React from "react";

const PerformanceMetricsCards: React.FC = () => {
    return (
        <div className="w-full">
            {/* Top Row - 4 cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-2">
                {/* Total RX Verified Today */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col">
                    <span className="text-sm font-normal text-gray-700 mb-2">Total RX Verified Today</span>
                    <span className="text-4xl font-medium text-gray-900">348</span>
                </div>

                {/* Avg. Verification Time */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col">
                    <span className="text-sm font-normal text-gray-700 mb-2">Avg. Verification Time</span>
                    <span className="text-4xl font-medium text-gray-900">4.2m</span>
                    <div className="flex flex-row items-center gap-x-1 mt-2">
                        <svg className="w-4 h-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                        </svg>
                        <span className="text-sm text-gray-500">+5% from yesterday</span>
                    </div>
                </div>

                {/* Intervention Rate */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col">
                    <span className="text-sm font-normal text-gray-700 mb-2">Intervention Rate</span>
                    <span className="text-4xl font-medium text-gray-900">1.2%</span>
                    <div className="flex flex-row items-center gap-x-1 mt-2">
                        <svg className="w-4 h-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                        <span className="text-sm text-gray-500">-5% from average</span>
                    </div>
                </div>

                {/* Overall Customer Satisfaction */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col">
                    <span className="text-sm font-normal text-gray-700 mb-2">Overall Customer Satisfaction</span>
                    <span className="text-4xl font-medium text-gray-900">94%</span>
                    <div className="w-full bg-gray-200 rounded-none h-7 mt-3">
                        <div className="bg-blue-600 h-7 rounded-none" style={{ width: '94%' }} />
                    </div>
                </div>
            </div>

            {/* Bottom Row - 4 cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 h-[150px]">
                {/* Avg Accuracy */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col items-start justify-between">
                    <div className="flex flex-row items-center gap-x-2 mb-3">
                        <CheckCircle className="w-5 h-5 text-green-500" />
                        <span className="text-sm font-normal text-gray-700">Avg Accuracy</span>
                    </div>
                    <div className="flex flex-col items-start justify-end">
                        <span className="text-3xl font-semibold text-gray-900">98.1%</span>
                        <span className="text-sm text-gray-500 mt-1">Across all staff</span>
                    </div>
                </div>

                {/* Avg Rating */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col items-start justify-between">
                    <div className="flex flex-row items-center gap-x-2 mb-3">
                        <Award className="w-5 h-5 text-orange-500" />
                        <span className="text-sm font-normal text-gray-700">Avg Rating</span>
                    </div>
                    <div className="flex flex-col items-start justify-end">
                        <div className="flex flex-row items-center gap-x-1">
                            <span className="text-3xl font-semibold text-gray-900">4.6</span>
                            <span className="text-2xl">★</span>
                        </div>
                        <span className="text-sm text-gray-500 mt-1">Customer satisfaction</span>
                    </div>
                </div>

                {/* Total Processed */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col items-start justify-between">
                    <div className="flex flex-row items-center gap-x-2 mb-3">
                        <TrendingUp className="w-5 h-5 text-blue-500" />
                        <span className="text-sm font-normal text-gray-700">Total Processed</span>
                    </div>
                    <div className="flex flex-col items-start justify-end">
                        <span className="text-3xl font-semibold text-gray-900">992</span>
                        <span className="text-sm text-gray-500 mt-1">This month</span>
                    </div>
                </div>

                {/* Total Staff */}
                <div className="border border-gray-200 rounded-lg p-4 flex flex-col items-start justify-between">
                    <div className="flex flex-row items-center gap-x-2 mb-3">
                        <Users className="w-5 h-5 text-blue-500" />
                        <span className="text-sm font-normal text-gray-700">Total Staff</span>
                    </div>
                    <div className="flex flex-col items-start justify-end">
                        <span className="text-3xl font-semibold text-gray-900">4</span>
                        <span className="text-sm text-gray-500 mt-1">2 Pharmacists, 2 Technicians</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PerformanceMetricsCards;
